import { handleError } from './handlers/handleError';
import { handleLocationChange } from './handlers/handleLocationChange';
import { handleMultilingual } from './handlers/handleMultilingual';
import { handleRTL } from './handlers/handleRTL';
export var controllerFactory = function (ControllerConstructor) { return function (controllerParams) {
    var controller = new ControllerConstructor(controllerParams);
    return {
        pageReady: function () {
            return Promise.resolve()
                .then(handleRTL(controllerParams))
                .then(function () { return Promise.all([handleMultilingual(controllerParams, controller.getFreeTexts()), controller.init()]); })
                .then(handleLocationChange(controllerParams, function () { return void controller.load(); }))
                .catch(handleError(controllerParams));
        },
        exports: function () {
            return controller.exports();
        },
        updateConfig: function (_$w, _a) {
            var style = _a.style;
            return void controller.onStyleUpdate(style.styleParams);
        },
    };
}; };
//# sourceMappingURL=controllerFactory.js.map